var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgIndicator = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7001 8.9L13.4001 9.2C12.6001 9.2 11.9001 8.7 11.9001 7.9L11.6001 5.5H11.7001L15.7001 8.9Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6002 17.7016C16.7002 18.5016 16.1002 19.2016 15.4002 19.2016L7.9002 20.0016H7.8002H7.6002C6.8002 20.1016 6.1002 19.5016 6.1002 18.8016L5.0002 7.60156C4.9002 6.80156 5.5002 6.10156 6.2002 6.10156L11.5002 5.60156H11.6002L11.8002 7.90156C11.8002 8.10156 11.9002 8.30156 12.0002 8.40156C12.1002 8.50156 12.2002 8.70156 12.3002 8.80156C12.6002 9.10156 13.0002 9.20156 13.4002 9.20156H13.6002H13.7002L15.7002 9.00156L16.6002 17.7016Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3003 8.90156L15.9003 9.00156H15.8003L14.0003 9.20156C13.9003 9.20156 13.8003 9.20156 13.8003 9.20156C13.1003 9.20156 12.6003 8.60156 12.5003 8.00156L12.3003 6.10156V6.00156V5.60156H12.4003L16.3003 8.90156Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 17.7016C16.7003 18.5016 16.1003 19.2016 15.4003 19.2016L7.9003 20.0016C7.3003 19.9016 6.7003 19.4016 6.7003 18.8016L5.6003 7.60156C5.5003 6.80156 6.1003 6.10156 6.8003 6.10156L11.6003 5.60156H11.7003H12.0003H12.1003V6.00156V6.10156L12.3003 7.90156C12.4003 8.60156 12.9003 9.10156 13.6003 9.10156C13.7003 9.10156 13.8003 9.10156 13.8003 9.10156L15.8003 9.00156L16.6003 17.7016Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 8.3H16.3002C15.4002 8.3 14.7002 7.6 14.7002 6.7V4L14.8002 4.1L19.0002 8.3Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0004 8.3V18.4C19.0004 19.3 18.3004 20 17.4004 20H8.50039C7.60039 20 6.90039 19.3 6.90039 18.4V5.6C6.90039 4.7 7.60039 4 8.50039 4H14.6004H14.7004V6.7C14.7004 7.6 15.4004 8.3 16.3004 8.3H19.0004Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 8.3V18.4C19.0002 19.3 18.3002 20 17.4002 20H9.3002C8.4002 20 7.7002 19.3 7.7002 18.4V5.6C7.7002 4.7 8.4002 4 9.3002 4H14.6002H14.7002V6.7C14.7002 7.6 15.4002 8.3 16.3002 8.3H19.0002Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1996 12.8V9.5C11.5996 9.6 10.2996 10.8 10.0996 12.3C10.0996 12.5 10.2996 12.8 10.4996 12.8H13.1996Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3998 16.6C12.3998 16 12.3998 14.3 12.3998 13.7C12.3998 13.6 12.2998 13.5 12.1998 13.5H9.4998C9.3998 13.5 9.2998 13.6 9.2998 13.7C9.3998 15.3 10.6998 16.6 12.1998 16.8C12.2998 16.8 12.3998 16.7 12.3998 16.6Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0998 10.9C15.4998 10 14.4998 9.5 13.3998 9.5H13.2998V12.8L16.0998 10.9Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5997 12.8008H13.1997V15.8008C13.1997 16.0008 13.2997 16.1008 13.4997 16.1008C15.2997 16.0008 16.5997 14.5008 16.5997 12.8008Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5997 12.8C16.5997 12.1 16.3997 11.5 15.9997 11L13.1997 12.8H16.5997Z",
    fill: "url(#paint9_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.6377,
    y1: 9.2,
    x2: 13.4519,
    y2: 7.46438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16.196,
    y1: 4.49953,
    x2: 8.60726,
    y2: 15.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 18.4549,
    y1: 4.7099,
    x2: 13.1395,
    y2: 9.5421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 17.5077,
    y1: 8.2294,
    x2: 0.474091,
    y2: 22.3636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 17.6719,
    y1: 2.8036,
    x2: 2.6921,
    y2: 34.6961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 10.6256,
    y1: 13.2433,
    x2: 14.0865,
    y2: 9.4629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 12.0059,
    y1: 13.8716,
    x2: 10.5471,
    y2: 15.5466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414298,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7869,
    stopColor: "#F56D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 11.1881,
    y1: 10.992,
    x2: 17.1809,
    y2: 11.3619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 13.1804,
    y1: 15.9148,
    x2: 15.1225,
    y2: 12.9739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 13.5975,
    y1: 11.7048,
    x2: 17.3153,
    y2: 12.2042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414298,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7869,
    stopColor: "#F56D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIndicator, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Indicator.258e857d.svg";
export { ForwardRef as ReactComponent };